import React from 'react';
import { Col, Row } from 'reactstrap';
import roundRightArrow from '../../../images/roundRightArrow.png'
import './index.css';

export const DealerCard = ({ cardData, handleCountClick, handleTitleClick }) => {
    const { first_name, last_name, role, count, state } = cardData
    return (
        <div className="dealerCard" id='dealerCard'>
            <div className="dealerCardTitle m-0" onClick={((role === "SH" || role === "NH")) ? handleTitleClick : handleCountClick}
                style={{ cursor: 'pointer' }}
            >
                <div className='flex-grow-1'>{`${role} ${state ? `(${state})` : ''} : ${first_name} ${last_name}`}</div>
                <div className='titleArrow'>
                    <img src={roundRightArrow} alt="roundRightArrow" />
                </div>
            </div>
            <div className="dealerCardInner">
                <Row className="justify-content-center">
                    <Col xs={12}>
                        <div className='dealerCardBlock'>
                            <div className='dealerNumber green' onClick={handleCountClick}>{count}</div>
                        </div>
                    </Col>
                </Row>
            </div>
        </div >
    )
}